module.exports = __webpack_public_path__ + "img/tarj2-8.fce40642.svg";